import React, { useEffect, useRef, useState } from "react";
import translations from "../../translations/translations";
import "./addressAutocomplete.css";

const MAPBOX_TOKEN = process.env.REACT_APP_MAP_BOX_TOKEN;

/* ---------------- Helpers ---------------- */

const getCityFromContext = (context = []) => {
	return (
		context.find((c) => c.id.startsWith("place"))?.text ||
		context.find((c) => c.id.startsWith("locality"))?.text ||
		context.find((c) => c.id.startsWith("neighborhood"))?.text ||
		context.find((c) => c.id.startsWith("region"))?.text ||
		""
	);
};

const getCountryFromContext = (context = []) => {
	return context.find((c) => c.id.startsWith("country"))?.text || "";
};

/* ---------------- Component ---------------- */

function RSFNewAutocomplete({ value, onChange, onSelect, language }) {
	const [query, setQuery] = useState(value || "");
	const [results, setResults] = useState([]);
	const [hasInteracted, setHasInteracted] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const lastSearchedRef = useRef("");

	// Sync external value → input
	useEffect(() => {
		setQuery(value || "");
	}, [value]);

	useEffect(() => {
		if (
			!hasInteracted ||
			!query ||
			query.length < 4 ||
			query === lastSearchedRef.current
		) {
			setResults([]);
			setIsLoading(false);
			return;
		}

		const controller = new AbortController();

		const fetchSuggestions = async () => {
			try {
				lastSearchedRef.current = query;

				const res = await fetch(
					`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
						query
					)}.json?access_token=${MAPBOX_TOKEN}&autocomplete=true&limit=5&country=ca,us,do&language=${language}`,
					{ signal: controller.signal }
				);

				const data = await res.json();
				setResults(data.features || []);
			} catch (err) {
				if (err.name !== "AbortError") {
					console.error("Mapbox geocoding error:", err);
				}
			} finally {
				setIsLoading(false);
			}
		};

		// ⏱️ cheap debounce: wait 1s after typing stops
		const timeout = setTimeout(fetchSuggestions, 1000);

		return () => {
			controller.abort();
			clearTimeout(timeout);
		};
	}, [query, language, hasInteracted]);

	return (
		<div className="rsf-ac-wrapper">
			<input
				className="sf-book-input"
				value={query}
				onFocus={() => setHasInteracted(true)}
				onChange={(e) => {
					const val = e.target.value;
					setHasInteracted(true);
					setQuery(val);

					// 👇 skeleton shows immediately while waiting
					setIsLoading(val.length >= 4);

					onChange(val);
				}}
				placeholder={
					translations[language]?.profile?.modal?.shopInfo?.address
				}
				autoComplete="off"
			/>

			{(isLoading || results.length > 0) && (
				<ul className="rsf-ac-dropdown">
					{isLoading
						? Array.from({ length: 4 }).map((_, idx) => (
								<li
									key={idx}
									className="rsf-ac-item rsf-ac-skeleton"
								>
									<div className="rsf-ac-skeleton-line" />
								</li>
						  ))
						: results.map((feature) => {
								const [lng, lat] = feature.center || [];
								const city = getCityFromContext(feature.context);
								const country = getCountryFromContext(feature.context);

								return (
									<li
										key={feature.id}
										className="rsf-ac-item"
										onMouseDown={(e) => {
											e.preventDefault();

											onSelect({
												address: feature.place_name,
												city,
												country,
												lat,
												lng,
											});

											setQuery(feature.place_name);
											setResults([]);
											setHasInteracted(false);
										}}
									>
										{feature.place_name}
									</li>
								);
						})}
				</ul>
			)}
		</div>
	);
}

export default RSFNewAutocomplete;





// import React, { useEffect, useState } from "react";
// import translations from "../../translations/translations";
// import "./addressAutocomplete.css";

// const MAPBOX_TOKEN = process.env.REACT_APP_MAP_BOX_TOKEN;

// /* ---------------- Helpers ---------------- */

// const getCityFromContext = (context = []) => {
// 	return (
// 		context.find((c) => c.id.startsWith("place"))?.text ||
// 		context.find((c) => c.id.startsWith("locality"))?.text ||
// 		context.find((c) => c.id.startsWith("neighborhood"))?.text ||
// 		context.find((c) => c.id.startsWith("region"))?.text ||
// 		""
// 	);
// };

// const getCountryFromContext = (context = []) => {
// 	return (
// 		context.find((c) => c.id.startsWith("country"))?.text || ""
// 	);
// };

// /* ---------------- Component ---------------- */

// function RSFNewAutocomplete({ value, onChange, onSelect, language }) {
// 	const [query, setQuery] = useState(value || "");
// 	const [results, setResults] = useState([]);
// 	const [loading, setLoading] = useState(false);

// 	// Keep internal query in sync with parent value
// 	useEffect(() => {
// 		setQuery(value || "");
// 	}, [value]);

// 	useEffect(() => {
// 		if (!query || query.length < 3) {
// 			setResults([]);
// 			return;
// 		}

// 		const controller = new AbortController();

// 		async function fetchSuggestions() {
// 			setLoading(true);

// 			try {
// 				const res = await fetch(
// 					`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
// 						query
// 					)}.json?access_token=${MAPBOX_TOKEN}&autocomplete=true&limit=5&country=ca,us,do&language=${language}`,
// 					{ signal: controller.signal }
// 				);

// 				const data = await res.json();
// 				setResults(data.features || []);
// 			} catch (err) {
// 				if (err.name !== "AbortError") {
// 					console.error("Mapbox geocoding error:", err);
// 				}
// 			} finally {
// 				setLoading(false);
// 			}
// 		}

// 		const timeout = setTimeout(fetchSuggestions, 250); // debounce

// 		return () => {
// 			controller.abort();
// 			clearTimeout(timeout);
// 		};
// 	}, [query, language]);

// 	return (
// 		<div style={{ position: "relative" }}>
// 			<input
// 				className="sf-book-input"
// 				value={query}
// 				onChange={(e) => {
// 					const val = e.target.value;
// 					setQuery(val);
// 					onChange(val);
// 				}}
// 				placeholder={
// 					translations[language].profile.modal.shopInfo.address
// 				}
// 				autoComplete="off"
// 			/>

// 			{results.length > 0 && (
// 				<ul className="sf-autocomplete-dropdown">
// 					{results.map((feature) => {
// 						const [lng, lat] = feature.center || [];

// 						const city = getCityFromContext(feature.context);
// 						const country = getCountryFromContext(feature.context);

// 						return (
// 							<li
// 								key={feature.id}
// 								className="sf-autocomplete-item"
// 								onClick={() => {
// 									onSelect({
// 										address: feature.place_name,
// 										city,
// 										country,
// 										lat,
// 										lng,
// 									});

// 									setQuery(feature.place_name);
// 									setResults([]);
// 								}}
// 							>
// 								{feature.place_name}
// 							</li>
// 						);
// 					})}
// 				</ul>
// 			)}
// 		</div>
// 	);
// }

// export default RSFNewAutocomplete;


//  /* global google */
// import { Loader } from "@googlemaps/js-api-loader";
// import React, { useState, useEffect, useRef } from "react";
// import translations from "../translations/translations";

// function RSFNewAutocomplete({ value, onChange, onSelect, language }) {
// 	const inputRef = useRef(null);

// 	useEffect(() => {
// 		if (!window.google || !inputRef.current) return;

// 		const autocomplete = new google.maps.places.Autocomplete(inputRef.current, {
// 			componentRestrictions: { country: ["ca", "us", "do"] },
// 			fields: ["formatted_address", "geometry", "address_components"],
// 		});

// 		autocomplete.addListener("place_changed", () => {
// 			const place = autocomplete.getPlace();
// 			if (!place.geometry) return;

// 			let city = "";
// 			let country = "";

// 			place.address_components.forEach((c) => {
// 				if (c.types.includes("locality")) city = c.long_name;
// 				if (c.types.includes("country")) country = c.long_name;
// 			});

// 			onSelect({
// 				address: place.formatted_address,
// 				city,
// 				country,
// 				lat: place.geometry.location.lat(),
// 				lng: place.geometry.location.lng(),
// 			});
// 		});
// 	}, []);

// 	return (
// 		<input
// 			ref={inputRef}
// 			className="sf-book-input"
// 			value={value}
// 			onChange={(e) => onChange(e.target.value)}
// 			placeholder={translations[language].profile.modal.shopInfo.address}
// 		/>
// 	);
// }


// export default RSFNewAutocomplete;
